module.exports = __webpack_public_path__ + "static/media/eopTotalNew.a76e3f22.png";